import { useState, useEffect } from "react";

import fetchSponsors from "../api/fetchSponsors"; // Adjust the path as needed

import SplashScreen from "../Components/SplashScreen/SplashScreen";
import BaseLayout from "../Components/BaseLayout/BaseLayout";
import Footer from "../Components/Footer/Footer";
import Menu from "../Components/Menu/Menu";

import "../styles/pages/sponsorsPage.scss";
import { PortableText } from "@portabletext/react";
import Sponsors from "../Components/Sponsors/Sponsors";

export const SponsorsPage = () => {
  const [showLoading, setShowLoading] = useState(true);
  const [sponsorsData, setSponsorsData] = useState(null);

  useEffect(() => {
    const loadData = async () => {
      const data = await fetchSponsors();
      console.log(data);

      setSponsorsData(data);
    };

    loadData();
  }, []);

  // Handle loading state
  useEffect(() => {
    const timeout = setTimeout(() => {
      setShowLoading(false);
    }, 3000);
    return () => clearTimeout(timeout);
  }, []);

  return (
    <>
      <Menu />
      {showLoading ? <SplashScreen /> : ""}
      <div className="sponsors-container fade-in">
        {sponsorsData ? (
          <>
            <BaseLayout title={sponsorsData.title} subTitle="Sponsors">
              <div className="sponsors-content">
                <div className={"sponsors-text block-content max-text-width"}>
                  <PortableText value={sponsorsData.content} />
                </div>
                {/* Page Image */}
                {console.log(sponsorsData.image)}
                {sponsorsData.image && (
                  <img
                    src={sponsorsData.imageUrl}
                    alt={sponsorsData.title}
                    className="sponsors-image"
                  />
                )}
              </div>
              <Sponsors />
            </BaseLayout>
            <Footer />
          </>
        ) : (
          <BaseLayout title={"Loading..."} subTitle="Our Sponsors" />
        )}
      </div>
    </>
  );
};

export default SponsorsPage;
